export type Environment =
    | "local"
    | "development"
    | "stage"
    | "production"
    | "test"

export const getEnvironment = (url: string): Environment => {
    const subdomain = new URL(url).hostname.split(".")[0]

    if (subdomain === "avytmpl-admin" && process.env.NODE_ENV === "test") {
        return "test"
    } else if (subdomain.startsWith("local")) {
        return "local"
    } else if (subdomain.startsWith("dev-")) {
        return "development"
    } else if (subdomain.startsWith("stage-")) {
        return "stage"
    } else {
        return "production"
    }
}

export const getFlutterManagerUrl = (): string => {
    const env = getEnvironment(window.location.href)

    if (env === "stage") {
        return "https://manager.stage.avy.io"
    } else if (env === "production") {
        return "https://manager.avy.io"
    } else {
        // Default to stage for local/dev/test environments
        return "https://manager.stage.avy.io"
    }
}
